<template>
    <div v-click-outside="closeMenu" class="relative shrink-0">
        <button
            class="min-w-7 cursor-pointer border-none bg-transparent px-0.5 py-1 text-sm font-semibold text-theme-text"
            aria-label="Playback speed"
            @click="handleButtonClick"
        >
            {{ speed }}x
        </button>
        <div
            v-show="isMenuVisible && !isMobile"
            class="absolute right-0 top-full z-[620] mt-1 min-w-16 rounded-lg border border-theme-border bg-theme-bg p-1 shadow-lg"
        >
            <button
                v-for="option in speedOptions"
                :key="option"
                class="block w-full cursor-pointer rounded border-none bg-transparent px-2.5 py-1.5 text-center text-[13px] text-theme-text hover:bg-theme-accent-bg"
                :class="{
                    'bg-theme-accent-bg font-semibold text-theme-accent': option === speed,
                }"
                @click="selectSpeed(option)"
            >
                {{ option }}x
            </button>
        </div>
    </div>
</template>

<script>
import { TTS_PLAYBACK_SPEED_OPTIONS } from '_shared_/js/constants/readerSelectionToolLimits.js';

/**
 * Speed control for TTS players.
 * - Desktop: Shows dropdown menu on click
 * - Mobile: Cycles through speeds on tap (like WhatsApp)
 */
export default {
    name: 'TtsSpeedControl',
    props: {
        speed: {
            type: Number,
            required: true,
        },
        isMenuVisible: {
            type: Boolean,
            default: false,
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['change', 'toggle-menu', 'close-menu'],
    data() {
        return {
            speedOptions: TTS_PLAYBACK_SPEED_OPTIONS,
        };
    },
    methods: {
        /**
         * Handles speed button click - cycles on mobile, toggles menu on desktop.
         */
        handleButtonClick() {
            if (this.isMobile) {
                this.cycleToNextSpeed();
            } else {
                this.$emit('toggle-menu');
            }
        },
        /**
         * Cycles to the next speed option (for mobile tap behavior).
         */
        cycleToNextSpeed() {
            const currentIndex = this.speedOptions.indexOf(this.speed);
            const nextIndex = (currentIndex + 1) % this.speedOptions.length;
            this.$emit('change', this.speedOptions[nextIndex]);
        },
        /**
         * Selects a speed from the dropdown menu.
         * @param {number} selectedSpeed - The selected speed value
         */
        selectSpeed(selectedSpeed) {
            this.$emit('change', selectedSpeed);
        },
        /**
         * Closes the speed menu (for v-click-outside).
         */
        closeMenu() {
            if (this.isMenuVisible) {
                this.$emit('close-menu');
            }
        },
    },
};
</script>
